export const SYF_NUMBER = '1 (844) 373-4960'

export const helpNumbers = {
  lowes: '1 (855) 945-3568',
  amazon: '1 (855) 890-8022',
  sams: '1 (844) 397-6504'
}
